import { useEffect, useState } from "react";
import { apiRequest } from "../../lib/api";
import { useAsync } from "../../hooks/useAsync";
import { useToast } from "../../context/ToastContext";

export function ScannerSettingsPanel() {
  const result = useAsync(() => apiRequest<{ enabled: boolean }>("/admin/security/scanner"), []);
  const [enabled, setEnabled] = useState(true);
  const [busy, setBusy] = useState(false);
  const { showToast } = useToast();
  useEffect(() => { if (result.data) setEnabled(result.data.enabled); }, [result.data]);
  async function save() {
    if (!enabled && !window.confirm("Disable malware scanning? Staff will be able to download unscanned and blocked files. Only open files you trust.")) return;
    setBusy(true);
    try {
      await apiRequest("/admin/security/scanner", { method: "PUT", body: { enabled } });
      showToast("Scanner settings saved.", "success");
      await result.refresh();
    } catch (error) { showToast(error instanceof Error ? error.message : "Could not save scanner settings.", "error"); }
    finally { setBusy(false); }
  }
  return <section className="settings-section card">
    <header><div><h2>Attachment malware scanner</h2><p>Enabled by default. Only administrators can change this setting.</p></div></header>
    <div className="inline-admin-form">
      {result.error ? <p role="alert">{result.error} <button type="button" onClick={() => void result.refresh()}>Retry</button></p>
        : result.loading && !result.data ? <p role="status">Loading scanner settings...</p> : <>
          <label className="checkbox-field"><input type="checkbox" checked={enabled} onChange={(event) => setEnabled(event.target.checked)} /> Enable malware scanning</label>
          <p className="muted-copy">{enabled
            ? "Attachments must pass the security scan before download. Paused scans resume automatically after scanning is enabled again."
            : "Scanning is paused. Agents and administrators can download files without a clean verdict, including previously blocked files. Customer access remains protected. Existing scan results are not changed."}</p>
          <div className="form-actions"><button type="button" className="button button--primary" disabled={busy || enabled === result.data?.enabled} onClick={() => void save()}>{busy ? "Saving..." : "Save scanner settings"}</button></div>
        </>}
    </div>
  </section>;
}
